import moment from 'moment';
import { DAS_SOCKET_DATA, DTS_SOCKET_DATA, FIELD_LITHOLOGY_INFO, FIELD_LITHOLOGY_INFO_ERROR, FIELD_LITHOLOGY_INFO_SUCCESS, PLOT_WELL_DATA_INFO, PLOT_WELL_DATA_INFO_ERROR, PLOT_WELL_DATA_INFO_SUCCESS, VSP_INVERSION_LIST, VSP_INVERSION_LIST_ERROR, VSP_INVERSION_LIST_SUCCESS, VSP_INVERSION_PLOT, VSP_INVERSION_PLOT_ERROR, VSP_INVERSION_PLOT_SUCCESS, VSP_SURVEY_CREATE, VSP_SURVEY_CREATE_ERROR, VSP_SURVEY_CREATE_SUCCESS, VSP_SURVEY_DELETE, VSP_SURVEY_DELETE_ERROR, VSP_SURVEY_DELETE_SUCCESS, VSP_SURVEY_DETAILS, VSP_SURVEY_DETAILS_ERROR, VSP_SURVEY_DETAILS_SUCCESS, VSP_SURVEY_INFO, VSP_SURVEY_INFO_ERROR, VSP_SURVEY_INFO_SUCCESS, VSP_SURVEY_LIST, VSP_SURVEY_LIST_ERROR, VSP_SURVEY_LIST_SUCCESS } from './constants';

export default function vspSurveyReducer(state, action) {
	let pagination = {};
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const vspSurvey_data = [];
	const vspInversionData =[];

	switch (action.type) {
	case VSP_SURVEY_INFO:
		return {...state, loading : true, error : false };
	case VSP_SURVEY_INFO_SUCCESS :
		return {...state, vspSurveyData : action?.payload?.data, loading :false, error : false};
	case VSP_SURVEY_INFO_ERROR:
		return {...state, loading : false, error : true };


	case DTS_SOCKET_DATA : 	
		return { ...state, dtsData: action.payload };
	
	case DAS_SOCKET_DATA : 	
		return { ...state, dasData: action.payload };
		
	case VSP_SURVEY_LIST : 
		return { ...state, loading : true, error : false};
	case VSP_SURVEY_LIST_SUCCESS : 
		if(action.payload && action.payload.data && action.payload.data.length > 0){
			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
                    
			}
			action.payload && action.payload.data.map((item) => {
				const shotDatetime = moment.utc(item.shotDatetime).toDate();
				shotDatetime.toString();
				const newDateTimeFrom = moment(shotDatetime, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			
				vspSurvey_data.push({
					id : item.id,
					name : item.name,

					sourceTypeId : item.sourceTypeId,
					sourceType : item?.vspsurveysource?.name,
				
					seriesId : item.seriesId,
					surveySeries : item?.surveyseries?.name,
					surveyStatus : item?.surveyseries?.status,
				
					offsetDistance : item?.offsetDistance ? item?.offsetDistance:0,
					shotDatetime : newDateTimeFrom,
				
					wellinfoId:item?.wellinfoId,
					wellinfo : item.wellinfo.name ? item.wellinfo.name.toUpperCase() : '',

					wellFieldId:item?.wellFieldId,
					wellfields : item?.wellfields.name ? item?.wellfields.name.toUpperCase() : '',

					status : item?.status,
					directory : item?.directory ? item?.directory : 'Nill',
					fileName :  item?.fileName ? item?.fileName : 'Nill',
					velocity :  item?.velocity ? item.velocity : 'Nill'
				
				});
			
			});
			return { ...state, vspSurvey_data : vspSurvey_data, loading : false, error : false, pagination:pagination};
		}else {			
                
			if (action.payload && action.payload.data.length == 0) {
                        
				return { ...state, vspSurvey_data: [], pending: false, error: false };
			} else {
    
				return { ...state, vspSurvey_data: [] , pending: false, error: true };
			}
		}
					
	case VSP_SURVEY_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case VSP_SURVEY_CREATE :
		return { ...state, loading : true, error : false};
	case VSP_SURVEY_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case VSP_SURVEY_CREATE_ERROR :
		return { ...state, loading : false, error : true };

	case VSP_SURVEY_DELETE :
		return { ...state, loading : true, error : false};
	case VSP_SURVEY_DELETE_SUCCESS :
		return { ...state, loading : false, error : false};
	case VSP_SURVEY_DELETE_ERROR : 
		return { ...state, loading : false, error : true };

	case FIELD_LITHOLOGY_INFO : 
		return { ...state, loading : true, error : false};
	case FIELD_LITHOLOGY_INFO_SUCCESS : 
		return { ...state, fieldLithology_data : action.payload, loading : false, error : false};
	case FIELD_LITHOLOGY_INFO_ERROR : 
		return { ...state, loading : false, error : true };

	case PLOT_WELL_DATA_INFO:
		return {...state, loading : true, error : false };
	case PLOT_WELL_DATA_INFO_SUCCESS :
		return {...state, plotWellData : action?.payload?.data, loading :false, error : false};
	case PLOT_WELL_DATA_INFO_ERROR:
		return {...state, loading : false, error : true };


	case VSP_SURVEY_DETAILS : 
		return { ...state, loading : true, error : false};
	case VSP_SURVEY_DETAILS_SUCCESS : 
		action.payload && action.payload.data.map((item) => {
			const shotDatetime = moment.utc(item.shotDatetime).toDate();
			shotDatetime.toString();
			const newDateTimeFrom = moment(shotDatetime, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			
			vspSurvey_data.push({
				id : item.id,
				name : item.name,

				sourceTypeId : item.sourceTypeId,
				sourceType : item?.vspsurveysource?.name,
				
				seriesId : item.seriesId,
				surveySeries : item?.surveyseries?.name,
				surveyStatus : item?.surveyseries?.status,
				
				offsetDistance : item?.offsetDistance ? item?.offsetDistance:0,
				shotDatetime : newDateTimeFrom,
				
				wellinfoId:item?.wellinfoId,
				wellinfo : item.wellinfo.name ? item.wellinfo.name.toUpperCase() : '',

				wellFieldId:item?.wellFieldId,
				wellfields : item?.wellfields.name ? item?.wellfields.name.toUpperCase() : '',

				status : item?.status,
				directory : item?.directory ? item?.directory : 'Nill',
				fileName :  item?.fileName ? item?.fileName : 'Nill',
				velocity :  item?.velocity ?  item?.velocity : 'Nill'
				
			});
			
		});
		return { ...state, vspSurveyDetail_data : vspSurvey_data, loading : false, error : false};
	case VSP_SURVEY_DETAILS_ERROR : 
		return { ...state, loading : false, error : true };

	
	case VSP_INVERSION_LIST : 
		return { ...state, loading : true, error : false};
	case VSP_INVERSION_LIST_SUCCESS : 

		if(action.payload && action.payload.data && action.payload.data.length > 0){
			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
                    
			}
			action.payload && action.payload.data.map((item) => {
				const datetime = moment.utc(item.datetime).toDate();
				datetime.toString();
				const newDateTimeFrom = moment(datetime, 'YYYY-MM-DD HH:mm:ss').format(settingsdateformat + ' ' + settingstimeformat);
			
				vspInversionData.push({
					id : item.id,

					seriesId : item.seriesId,
					surveySeries : item?.surveyseries?.name,

					datetime : newDateTimeFrom,

					wellFieldId: item?.wellFieldId,
					wellfields : item?.wellfields.name ? item?.wellfields.name.toUpperCase() : '',

					properties :  item?.properties ?  item?.properties : 'Nill'

				
				});
			
			});
			return { ...state, vspInversionData : vspInversionData, loading : false, error : false, pagination:pagination};
		}else {			
                
			if (action.payload && action.payload.data.length == 0) {
                        
				return { ...state, vspInversionData: [], pending: false, error: false };
			} else {
    
				return { ...state, vspInversionData: [] , pending: false, error: true };
			}
		}
		
		
	case VSP_INVERSION_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case VSP_INVERSION_PLOT:
		return {...state, loading : true, error : false };
	case VSP_INVERSION_PLOT_SUCCESS :
		return {...state, plotInversionData : action?.payload?.data, loading :false, error : false};
	case VSP_INVERSION_PLOT_ERROR:
		return {...state, loading : false, error : true };


	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}